export default __webpack_public_path__ + "static/Lato-Bold-5dd5aa0269395f0ea92763e6cb3bc07a.ttf";